import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';
import { API_CONFIG } from '../config/api.config';
import { ApiEnvelope, unwrapApiData } from '../models/api-response.model';
import type {
  CancelGatewayPaymentRequest,
  CancelGatewayPaymentResponse,
  ConfirmGatewayPaymentRequest,
  ConfirmGatewayPaymentResponse,
  InitiateGatewayPaymentRequest,
  InitiateGatewayPaymentResponse,
} from '../models/payment-gateway.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentGatewayService {
  constructor(private readonly http: HttpService) {}

  initiate(
    body: InitiateGatewayPaymentRequest,
  ): Observable<InitiateGatewayPaymentResponse> {
    return this.http
      .post<ApiEnvelope<InitiateGatewayPaymentResponse>>(
        API_CONFIG.paymentGateway.initiate,
        body,
      )
      .pipe(map((response) => unwrapApiData(response)));
  }

  confirm(
    body: ConfirmGatewayPaymentRequest,
  ): Observable<ConfirmGatewayPaymentResponse> {
    return this.http
      .post<ApiEnvelope<ConfirmGatewayPaymentResponse>>(
        API_CONFIG.paymentGateway.confirm,
        body,
      )
      .pipe(map((response) => unwrapApiData(response)));
  }

  cancel(
    body: CancelGatewayPaymentRequest,
  ): Observable<CancelGatewayPaymentResponse> {
    return this.http
      .post<ApiEnvelope<CancelGatewayPaymentResponse>>(
        API_CONFIG.paymentGateway.cancel,
        body,
      )
      .pipe(map((response) => unwrapApiData(response)));
  }
}
